<template>
    <div>
        <div class="page-content nestor-bomb-simulator" id="resultats">
            <div class="banniere">
                <div class="logo-lockquest" v-on:click="pageBackground_clicked"></div>
                <div class="logo-room"></div>
            </div>
            <div class="latest-score">
                <div>
                    <span>Date</span><!--
                    --><span>Rang</span><!--
                    --><span>Équipe</span><!--
                    --><span>Bonus</span><!--
                    --><span>Score</span>
                </div>
                <div v-if="latest_nestor_session">
                    <span>{{ latest_nestor_session.session_time.day }}/{{latest_nestor_session.session_time.month }}</span><!--
                    --><span>{{ latest_nestor_session.rank }}</span><!--
                    --><span>{{ latest_nestor_session.team_name }}</span><!--
                    --><span>
                        <template v-if="latest_nestor_session.boom_was_triggered">
                            <span class="boom"></span>
                        </template>
                        <template v-else>
                            <span class="star" v-for="num in latest_nestor_session.bonus"></span>
                        </template>
                    </span><!--
                    --><span>{{ latest_nestor_session.score }}</span>
                </div>
            </div>
            <div class="liste-scores" v-if="nestor_sessions">
                <div v-for="nestor_session in nestor_sessions" 
                    v-bind:class="{ 'first': nestor_session.rank == 1, 'second': nestor_session.rank == 2, 'third': nestor_session.rank == 3, 'default': nestor_session.rank > 3 }">
                    <span>{{ nestor_session.session_time.day }}/{{nestor_session.session_time.month }}</span><!--
                    --><span>{{ nestor_session.rank }}</span><!--
                    --><span>{{ nestor_session.team_name }}</span><!--
                    --><span>
                        <template v-if="nestor_session.boom_was_triggered">
                            <span class="boom"></span>
                        </template>
                        <template v-else>
                            <span class="star" v-for="num in nestor_session.bonus"></span>
                        </template>
                    </span><!--
                    --><span>{{ nestor_session.score }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: "ResultatsPage",
    components: {},
    data: () => ({
        nestor_sessions: null,
        latest_nestor_session: null,
        shouldDisplay_fullscreen: false
    }),
    methods: {
        pageBackground_clicked: function() {
            this.shouldDisplay_fullscreen = !this.shouldDisplay_fullscreen;
            if (this.shouldDisplay_fullscreen) {
                document.documentElement.webkitRequestFullscreen();
            } else {
                document.webkitExitFullscreen();
            }
        },
        display_listeScores: function() {
            this.nestor_sessions = null;
            this.latest_nestor_session = null;

            var self = this;
            axios.get('https://api.lockquest.fr/nestor_sessions?nb_items=50')
                .then((response) => {
                    self.nestor_sessions = response.data;
                    self.latest_nestor_session = self.nestor_sessions.shift();
                });
        }
    },
    mounted() {
        this.nestor_sessions = [
            { session_time: { day: 1, month: 1, year: 2025 }, rank: 1, team_name: 'Toto', bonus: 0, boom_was_triggered: false, score: 245 },
            { session_time: { day: 2, month: 1, year: 2025 }, rank: 2, team_name: 'Titi', bonus: 0, boom_was_triggered: true, score: 205 },
            { session_time: { day: 3, month: 2, year: 2025 }, rank: 3, team_name: 'Tata', bonus: 1, boom_was_triggered: false, score: 165 },
            { session_time: { day: 11, month: 4, year: 2025 }, rank: 4, team_name: 'Tutu', bonus: 2, boom_was_triggered: false, score: 145 },
            { session_time: { day: 27, month: 5, year: 2025 }, rank: 5, team_name: 'Tété', bonus: 3, boom_was_triggered: false, score: 120 },
            { session_time: { day: 27, month: 5, year: 2025 }, rank: 6, team_name: 'Oups', bonus: 4, boom_was_triggered: false, score: 110 },
            { session_time: { day: 27, month: 5, year: 2025 }, rank: 7, team_name: 'Zut', bonus: 5, boom_was_triggered: false, score: 100 }
        ];
        this.latest_nestor_session = { session_time: { day: 3, month: 2, year: 2025 }, rank: 3, team_name: 'Tata', results: 1, score: 165 };
        this.display_listeScores();
    }
}
</script>